import './stories-single-hero.scss';
